<template>
  <!-- 社教活动 -->
  <div class="page-education-activity">
    <div class="g-content-wrap">
      <!-- 搜索条件 -->
      <div class="com-list-header">
        <el-form class="com-search-box" ref="form" :model="form" label-width="0">
          <el-row :gutter="20">
            <el-col :span="4">
              <el-form-item label="" prop="city">
                <el-select v-model="form.city" filterable clearable placeholder="选择市" @change="getOrgData" style="width:100%;">
                  <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item label="" prop="orgId">
                <el-select v-model="form.orgId" filterable clearable placeholder="选择单位" style="width:100%;">
                  <el-option
                    v-for="item in orgList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item label="" prop="activityCategory">
                <el-select v-model="form.activityCategory" filterable clearable placeholder="活动类型" style="width:100%;">
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item label="" prop="activityStatus">
                <el-select v-model="form.activityStatus" filterable clearable placeholder="活动状态" style="width:100%;">
                  <el-option
                    v-for="item in statusList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="" prop="key">
                <el-input v-model="form.key" placeholder="活动名称："></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="com-head-search-btns">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <!-- <el-button @click="restList">重置</el-button> -->
        </div>
      </div>

      <div class="list mt-30">
        <div class="item g-card-2" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
          <div class="pic-box">
            <img v-lazy="item.pictureId" alt="" style="height:260px;">
            <!-- 0-报名中 2-已结束 1-已报满 -->
            <span class="g-status" v-if="item.activityStatus==='0'"><i></i>报名中</span>
            <span class="g-status g-status-end" v-if="item.activityStatus==='2'"><i></i>已结束</span>
            <span class="g-status g-status-full" v-if="item.activityStatus==='1'"><i></i>已报满</span>
          </div>
          <div class="g-border-box white">
            <div class="g-border">
              <span class="g-bor-dec g-bor-dec-1"></span>
              <span class="g-bor-dec g-bor-dec-2"></span>
              <span class="g-bor-dec g-bor-dec-3"></span>
              <span class="g-bor-dec g-bor-dec-4"></span>

              <div class="item-info">
                <h2 class="act-title ell">{{item.activityName}}</h2>
                <p>活动类型：{{item.activityCategory}}</p>
                <p>活动地点：{{item.activityPlace}}</p>
                <p>活动时间：{{item.activityTime}}</p>
                <div class="num-remain">
                  <div class="num-process">
                    <div class="process">
                      <!-- 0-报名中 2-已结束 1-已报满 -->
                      <el-progress :percentage="item.peopleNum/item.activityQuota*100" :show-text="false" color="#CCA176" v-if="item.activityStatus==='0'"></el-progress>
                      <el-progress :percentage="item.peopleNum/item.activityQuota*100" :show-text="false" color="#999493" v-if="item.activityStatus==='2'"></el-progress>
                      <el-progress :percentage="item.peopleNum/item.activityQuota*100" :show-text="false" color="#995314" v-if="item.activityStatus==='1'"></el-progress>
                    </div>
                    <p>已报名：{{item.peopleNum}}人</p>
                  </div>
                  <div class="num tc">
                    <p class="num-val">{{item.freeQuota}}</p>
                    <p>剩余名额</p>
                  </div>
                  <div class="btn-sign g-btn-level-1" v-if="item.activityStatus==='0'">我要报名</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 无数据 -->
        <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
          <div class="no-data-bg"></div>
          <p class="txt text-center">暂无数据</p>
        </div>
      </div>

      <cmpMyPagination :currentPage="listQuery.currentPage" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: '',
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 6,
      },
      total: 0,
      listLoading: false,
      form: {
        key: '',
        city: '',
        orgId: '',
        activityStatus: '',
        activityCategory: '',
      },
      cityList: [],
      orgList: [],
      typeList: [],
      statusList: [
        {
          name: '报名中',
          id: '0'
        },
        {
          name: '已报满',
          id: '1'
        },
        {
          name: '已结束',
          id: '2'
        }
      ]
    }
  },
  methods: {
    getDataList() {
      this.listLoading = true
      this.$http
      // ?orgId=60&currentPage=1&size=10&city=1376&key=&activityStatus=0
        .get('/activity/getActivityList.do', {
          ...this.listQuery,
          ...this.form
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.dataList = res.data
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getCityData() {
      this.$http
        .get('/api/spreadtrum/getCityList.do', {})
        .then(res => {
          if (res.success) {
            this.cityList = res.data
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getOrgData() {
      this.$http
        .get('/api/spreadtrum/getMuseumList.do', {
          city: this.form.city
        })
        .then(res => {
          if (res.success) {
            this.orgList = res.data
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getTypeData() {
      this.$http
        .get('/activity/getType.do', {})
        .then(res => {
          if (res.success) {
            this.typeList = res.data
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleSearch() {
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    goDetail(item) {
      this.$router.push({
        path: '/education/activity-detail',
        query: {id: item.id}
      })
    },
    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      this.listQuery.size = obj.size
      this.getDataList()
    },
  },
  created() {
    this.getCityData()
    this.getOrgData()
    this.getTypeData()
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.page-education-activity {
  .item {
    .item-info {
      background: #fff;
      font-size: 14px;
      line-height: 26px;
      color: #45443E;
      h2 {
        margin-bottom: 12px;
        font-size: 22px;
        color: #45443E;
        line-height: 32px;
      }
      .num-remain {
        margin-top: 20px;
        display: flex;
        font-size: 14px;
        color: #999493;
        .num {
          width: 80px;
          .num-val {
            font-size: 26px;
            line-height: 30px;
            color: #292423;
          }
        }
        .num-process {
          padding-top: 32px;
          position: relative;
          flex: 1;
          .progress-2 {
            display: none;
          }
          p {
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        .btn-sign {
          width: 143px;
          margin-left: 10px;
          position: relative;
          top: 10px;
        }
      }

    }
  }
}
</style>

